export default __webpack_public_path__ + "5ba2fe3ce7599727618c3baafbceacf1.png";